import React from 'react';
import { Control, FieldErrors } from 'react-hook-form';
import { CollaboratorFormContext } from "@/features/Collaborators/Edit/Contexts/CollaboratorFormContext";
import { CollaboratorFormData } from '@/features/Collaborators/Edit/Types';
import { GiftsAndPreferencesFieldset } from '@/features/Collaborators/Edit/Form/Fieldsets';

interface AboutYouStepProps {
    context: CollaboratorFormContext;
    collaboratorId: string;
    control: Control<CollaboratorFormData>;
    errors: FieldErrors<CollaboratorFormData>;
    isSubmitting?: boolean;
}

const AboutYouStep: React.FC<AboutYouStepProps> = ({
    context,
    collaboratorId,
    control,
    errors,
    isSubmitting = false
}) => {
    return (
        <div className="p-6">
            <div className="space-y-6">
                <div className="text-sm text-gray-600 bg-blue-50 p-4 rounded-md">
                    <p>
                        Queremos te conhecer melhor! Suas respostas nos ajudam a criar um ambiente de trabalho mais conectado e a preparar surpresas e ações personalizadas. Fique à vontade para compartilhar um pouco sobre você.
                    </p>
                </div>

                <GiftsAndPreferencesFieldset context={context} control={control} />
            </div>
        </div>
    );
};

export default AboutYouStep;
